// Inside Claude only: load the signed-in user's profile and company data before
// the first render, the same steps signIn.jsx takes after a login.
//
// Claude opens straight onto a screen (usually /canvas/<id>), and the canvas
// reads the company's ERP coding lists on mount, once. In the browser those are
// loaded at login; inside Claude there is no login, and App.js's profile
// recovery resolves only after the canvas has already mounted with empty
// dropdowns. So the store is filled first, then the app renders.

import { getInfo } from '../services/services';
import { setErpTypeInSession } from '../services/common';
import { user_information, load_synced_data, load_field_config } from '../redux/actions/action';
import { userRoles } from '../constants/appConstants';

const rehydrated = (persistor) =>
  new Promise((resolve) => {
    if (persistor.getState().bootstrapped) return resolve();
    const unsubscribe = persistor.subscribe(() => {
      if (persistor.getState().bootstrapped) {
        unsubscribe();
        resolve();
      }
    });
  });

export async function prepareEmbeddedSession(store, persistor) {
  // Rehydration must land first, or it would overwrite what is dispatched here.
  await rehydrated(persistor);
  const username = sessionStorage.getItem('cognitoUsername');
  const res = await getInfo(username, () => ({}));
  if (res?.status !== 200) return; // App.js's recovery retries and reports
  const profile = res.data?.payload?.data;
  store.dispatch(user_information(profile));
  if (profile?.user?.erpType) setErpTypeInSession(profile.user.erpType);
  const companyId = profile?.company?._id;
  if (companyId && sessionStorage.getItem('userRole') !== userRoles.VENDOR) {
    await Promise.all([
      store.dispatch(load_synced_data(companyId)),
      store.dispatch(load_field_config(companyId))
    ]);
  }
}
